// src/utils/sampleData.js
// Shared sample/demo data used for the "Try Demo" experience and the manual paste sample.

export const SAMPLE_DATA_TEXT = `Cup of the Day	Map	Division	Division Rank	Rank	Qualification
COTD 2025-07-26 #1

16 hours ago

Flow State	
12
1st / 46
705th / 2134 (top 33.04%)	761st / 2134 (top 35.66%)
COTD 2025-07-23 #1

4 days ago

Prohibit ft' speq	
16
12th / 45
972nd / 2319 (top 41.91%)	1,016th / 2319 (top 43.81%)
COTD 2025-07-22 #1

5 days ago

ক ft' cotton	
8
14th / 50
462nd / 2429 (top 19.02%)	450th / 2429 (top 18.53%)
COTD 2025-07-20 #1

7 days ago

Never Odd or Even ft Pepsy	
9
21st / 44
533rd / 2375 (top 22.44%)	548th / 2375 (top 23.07%)
COTD 2025-07-13 #1

14 days ago

Piece of Oblivion ft Quinn22b1	
9
27th / 53
539th / 2177 (top 24.76%)	573rd / 2177 (top 26.32%)
COTD 2025-07-07 #1

20 days ago

P1NO R1V13RA	
11
28th / 50
668th / 2512 (top 26.59%)	703rd / 2512 (top 27.99%)
COTD 2025-07-06 #1

21 days ago

wowie [ce] ft' Pac042	
13
11th / 48
779th / 2340 (top 33.29%)	816th / 2340 (top 34.87%)
COTD 2025-05-28 #1

2 months ago

Herzrasen kann man nicht mähen	
10
6th / 55
582nd / 2700 (top 21.56%)	599th / 2700 (top 22.19%)
COTD 2025-05-27 #1

2 months ago

Cream ft n1x	
6
31st / 46
351st / 2770 (top 12.67%)	342nd / 2770 (top 12.35%)
COTD 2025-05-26 #1

2 months ago

Porcelain	
12
6th / 46
710th / 3176 (top 22.36%)	745th / 3176 (top 23.46%)`;

export default SAMPLE_DATA_TEXT;
